import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-file-manager',
  templateUrl: './file-manager.component.html',
  standalone: false
})
export class FileManagerComponent implements OnInit {
  @Output() selectedFiles = new EventEmitter<[]>();
  @Output() deletedFilesList = new EventEmitter<[]>();
  @Input() deleteAutomatically: boolean = true;

  @Input() isRequired!: boolean;
  @Input() Disapled!: boolean;
  @Input() isSubmitted!: boolean;
  @Input() cols = 1;
  @Input() label!: string;
  @Input() invalidFileExtensions: string = "fileManager.invalidFileExtensions";
  @Input() required: string = "forms.Required";

  @Input() allowedExt: any[] = [
    'pdf',
    'jpeg',
    'jpg',
    'png',
    'doc',
    'docx',
    'wpd',
    'tex',
    'ppt',
    'pptx',
    'xlsx',
    'xls',
    'zip',
    'rar',
    'mp4'
  ];
  acceptExt = '';

  @Input() renderBtn = false;

  // Uploader
  @Input() isUploader = false;
  @Input() uplodaerType = 0;
  uploadedFilesArr: any = [];

  // DnD setting
  @Input() files: any = [];
  @Input() docsEditable = true;
  @Input() canDelete = false;
  @Input() maxFiles!: number;
  @Input() maxSize = 5;
  @Input() managerIndex: any = '0'; // in add numbertab_numberneeded, in details numbertab_d_numberneeded in "''"

  loading = false;
  selectedfilesCount = 0;
  deletedFiles: any = [];
  validFile = true;
  fileMaxSiZeErorr = false;
  fileMaxNameSiZeErorr = false;

  constructor(
    // private service: CabsRequestService,
    private translate: TranslateService,
    private http: HttpClient
  ) { }

  ngOnInit() {
    if (this.files.length && this.isUploader) {
      this.files.forEach((file: any) => {
        this.uploadedFilesArr.push({
          fileName: file.name,
          fileUpload: file.token,
        });
      });
      this.selectedFiles.emit(this.uploadedFilesArr);
    }

    if (this.allowedExt.includes('pdf')) {
      this.acceptExt += 'application/pdf, ';
    }
    if (this.allowedExt.includes('jpeg') || this.allowedExt.includes('jpg')) {
      this.acceptExt += 'image/jpeg, ';
    }
    if (this.allowedExt.includes('png')) {
      this.acceptExt += 'image/png, ';
    }
    this.allowedExt.forEach((element) => {
      this.acceptExt += '.' + element + ', ';
    });
  }

  fileType(fileName: any) {
    const extension = fileName.split('.').pop().toLowerCase();
    if (!this.allowedExt.includes(extension)) {
      return false;
    }
    switch (extension) {
      case 'mp4':
        return 'mp4';
      case 'mkv':
        return 'mkv';
      case 'avi':
        return 'avi';
      case 'mov':
        return 'mov';
      case 'pdf':
        return 'pdf';
      case 'jpeg':
      case 'jpg':
        return 'jpg';
      case 'png':
        return 'png';
      case 'doc':
      case 'docx':
      case 'wpd':
      case 'tex':
        return 'doc';
      case 'xlsx':
      case 'xls':
        return 'xls';
      case 'zip':
      case 'rar':
        return 'zip';
      case 'ppt':
      case 'pptx':
        return 'pptx';
      case 'svs':
      case 'tif':
      case 'ndpi':
      case 'scn':
      case 'mrxs':
      case 'svslide':
      case 'bif':
        return 'wsi';
      default:
        return false;
    }
  }

  /**
   * on file drop handler
   */
  onFileDropped($event: any) {
    if (!this.Disapled) {
      this.prepareFilesList($event);
    }
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(event: any) {
    this.prepareFilesList(event.target.files);
    event.target.value = '';
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number, id: any) {
    if (id) {
      this.deletedFiles.push(id);
    }

    const deleted = this.files[index];
    if (this.deleteAutomatically) {
      this.files.splice(index, 1);
    }

    if (this.isUploader) {
      const deletedIndx = this.uploadedFilesArr.findIndex(
        (item: any) => item.fileUpload === deleted.token
      );
      this.uploadedFilesArr.splice(deletedIndx, 1);
      this.selectedFiles.emit(this.uploadedFilesArr);
    } else {
      this.selectedFiles.emit(this.files);
      this.deletedFilesList.emit(this.deletedFiles);
      if (this.deleteAutomatically) {
        this.deletedFiles = [];
      }
    }
    this.selectedfilesCount = this.files.length;
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {
    const filesToUpload: any[] = [];
    this.validFile = true;
    this.selectedfilesCount = this.files.length + files.length;
    if (this.selectedfilesCount > this.maxFiles) {
      return;
    }
    for (const item of files) {
      if (this.fileType(item.name)) {
        this.validFile = true;
      } else {
        this.validFile = false;
      }

      // Check file and push to array files
      if (
        item.size / (1024 * 1024) <= this.maxSize &&
        this.fileType(item.name)
      ) {
        item.fileType = this.fileType(item.name);
        this.files.push(item);
        filesToUpload.push(item);

        if (this.isUploader) {
          this.uploadFile(filesToUpload);
        } else {
          this.selectedFiles.emit(this.files);
        }

        if (item.size / (1024 * 1024) <= this.maxSize) {
          this.fileMaxSiZeErorr = false;
        }
      } else {
        if (item.size / (1024 * 1024) > this.maxSize) {
          this.fileMaxSiZeErorr = true;
        }
      }
    }
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes: number, decimals = 2) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  uploadFile(files: any) {
    this.loading = true;
    this.Disapled = true;
    // this.service.upload_file(files, this.uplodaerType).subscribe(
    //   (response) => {
    //     this.loading = false;
    //     this.Disapled = false;
    //     this.uploadedFilesArr.push(response.data);
    //     this.selectedFiles.emit(this.uploadedFilesArr);
    //   },
    //   (err) => {
    //     this.loading = false;
    //     this.Disapled = false;
    //   }
    // );
  }

  getDownloadFileName(path: string): string {
    if (!path) { return 'download'; }
    const cleanPath = path.split('?')[0].split('#')[0];
    const fileName = cleanPath.split('/').pop();
    return fileName ? decodeURIComponent(fileName) : 'download';
  }

  downloadFile(filePath: string): void {
    if (!filePath) { return; }
    this.http.get(filePath, { responseType: 'blob' }).subscribe({
      next: (blob: Blob) => {
        const fileName = this.getDownloadFileName(filePath);
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(blobUrl);
      }, error: (error) => {
        console.error('Download failed:', error);
      }
    });
  }
}
